import React, { useState, useEffect } from "react";
import Header from "./Header";
import SideMenu from "./SideMenu";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import config from './config';
import './App.css';

function ReporteEstadoPago() {
  const location = useLocation();
  const [dataLogin, setDataLogin] = useState([]);
  const [estadosPago, setEstadosPago] = useState([]);
  const [maquinariasOptions, setMaquinariasOptions] = useState([]);
  const [clientesOptions, setClientesOptions] = useState([]);

  useEffect(() => {
    if (location.state) {
      const receivedData = location.state;
      setDataLogin(receivedData);
      obtenerMaquinarias();
      obtenerClientes();
    }
  }, [location]);

  const obtenerMaquinarias = async () => {
    try {
      const response = await fetch(`${config.apiBaseUrl}/maquinaria.php`);
      const data = await response.json();

      if(data && data[0].id_maquinaria){
        setMaquinariasOptions(data);
      }
    } catch (error) {
      setMaquinariasOptions([]);
    }
  };

  const obtenerClientes = async () => {
    try {
      const response = await fetch(`${config.apiBaseUrl}/cliente.php`);
      const data = await response.json();

      if(data && data[0].id_cliente){
        setClientesOptions(data);
      }
    } catch (error) {
      setClientesOptions([]);
    }
  };

  const [clienteSelected, setClienteSelected] = useState('');
  const [obras, setObras] = useState([]);

  const handleClienteSelect = async (clienteSelected) => {
    setClienteSelected(clienteSelected);
    await obtenerObras(clienteSelected);

    setFormConsultaData({
      ...formConsultaData,
      ["id_cliente"]: clienteSelected,
    });

    //console.log(formConsultaData);
  };
  
  const obtenerObras = async (cliente) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/reporte_estado_pago.php?id_cliente=${cliente}`
      );
      const data = await response.json();
      if (data && data[0].id_obra) {
        setObras(data);
      }
    } catch (error) {
      setObras([]);
    }
  };

  //Filtro Servicios
  const [filtroEstadoPago, setFiltroEstadoPago] = useState('');
  const manejarCambioFiltro = (event) => {
    setFiltroEstadoPago(event.target.value);
  };

  const estadosPagoFiltrados = estadosPago.filter((item) =>
    item.folio.toLowerCase().includes(filtroEstadoPago.toLowerCase())
  );

  const currentDate = new Date().toISOString().split('T')[0];
  const [formConsultaData, setFormConsultaData] = useState({
    id_maquinaria: 0,
    id_cliente: 0,
    id_obra: 0,
    fecha_inicio: currentDate,
    fecha_fin: currentDate,
  });

  const handleFormConsultaData = (e) => {
    const { name, value } = e.target;

    setFormConsultaData({
      ...formConsultaData,
      [name]: value,
    });

    //console.log(JSON.stringify(formConsultaData));
  };

  const handleBuscarEstadoPagoClick = async (event) => {
    event.preventDefault();

    try {
      const responseRequerimiento = await fetch(
        `${config.apiBaseUrl}/reporte_estado_pago.php`,
        {
          method: "POST",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json', 
          },
          body: JSON.stringify(formConsultaData),
        }
      );

      const dataRequerimiento = await responseRequerimiento.json();
      //console.log(JSON.stringify(dataRequerimiento,null,2));

      if (dataRequerimiento && dataRequerimiento[0].id_estado_pago) {
        setEstadosPago(dataRequerimiento);
      }

    } catch (error) {
      //console.log(error);
      setEstadosPago([]);
    }
  }

  const exportToExcel = () => {
    const ahora = new Date();
    const fechaFormateada = formatearFecha(ahora);

    const arregloExportar = estadosPago.map(obj => {
      return {
        ["Maquinaria"]: obj.nombre_maquinaria,
        ["Folio"]: obj.folio,
        ["Fecha Estado Pago"]: obj.fecha_estado_pago,
        ["Nombre Cliente"]: obj.nombre_cliente,
        ["Nombre Obra"]: obj.nombre_obra,
        ["Descuentos"]: Number(obj.otros_descuentos).toLocaleString('es-ES', { useGrouping: true }).replace(/[.,]/g, ''),
        ["Total Neto"]: Number(obj.total_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/[.,]/g, ''),
        ["IVA"]: Number(obj.iva).toLocaleString('es-ES', { useGrouping: true }).replace(/[.,]/g, ''),
        ["Total"]: Number(obj.total).toLocaleString('es-ES', { useGrouping: true }).replace(/[.,]/g, '')
      };
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(arregloExportar);
    XLSX.utils.book_append_sheet(wb, ws, 'Estados de pago');
    XLSX.writeFile(wb, 'Estados de Pago ' + fechaFormateada + '.xlsx');
  };

  const formatearFecha = (fecha) => {
    const dia = String(fecha.getDate()).padStart(2, '0');
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const year = fecha.getFullYear();
    const hora = String(fecha.getHours()).padStart(2, '0');
    const minutos = String(fecha.getMinutes()).padStart(2, '0');

    return `${dia}-${mes}-${year} ${hora}_${minutos}`;
  };

  return (
    <div className="d-flex" style={styles.mainContainer}>
      <SideMenu dataLogin={dataLogin} />
      <div className="w-100">
        <Header dataLogin={dataLogin} />
        <div className="container-fluid">
          <div className="row">
            <div className="col">
              <div className="d-flex gap-md-2 mb-3">
                <div>
                  <label className="form-label">Maquinaria</label>
                  <select className="form-select" name="id_maquinaria" value={formConsultaData.id_maquinaria} onChange={handleFormConsultaData}>
                    <option value="0">Todos</option>
                    {maquinariasOptions.map((maquinaria) => (
                      <option key={maquinaria.id_maquinaria} value={maquinaria.id_maquinaria}>{maquinaria.maquinaria}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="form-label">Cliente</label>
                  <select className="form-select" name="cliente" value={clienteSelected} onChange={(e) => handleClienteSelect(e.target.value)}>
                    <option value="0">Todos</option>
                    {clientesOptions.map((cliente) => (
                      <option key={cliente.id_cliente} value={cliente.id_cliente}>{cliente.nombre_cliente}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="form-label">Obra</label>
                  {obras.length > 0 ? (
                    <select className="form-select" name="id_obra" value={formConsultaData.id_obra} onChange={handleFormConsultaData}>
                      <option value="0">Todos</option>
                      {obras.map((obra) => (
                        <option key={obra.id_obra} value={obra.id_obra}>{obra.nombre}</option>
                      ))}
                    </select>
                  ) : (
                    <select className="form-select" name="id_obra">
                      <option value="0">Todos</option>
                    </select>
                  )}
                </div>  
                <div>
                  <label className="form-label">Fecha Inicio</label>
                  <input
                    className="form-control"
                    type="date"
                    name="fecha_inicio"
                    value={formConsultaData.fecha_inicio}
                    onChange={handleFormConsultaData}
                  />
                </div>
                <div className="">
                  <label className="form-label">Fecha Fin</label>
                  <input
                    className="form-control"
                    type="date"
                    name="fecha_fin"
                    value={formConsultaData.fecha_fin}
                    onChange={handleFormConsultaData}
                  />
                </div>     
                <div>
                  <label className="form-label d-block">&nbsp; </label>
                  <button className="btn btn-yellow" onClick={handleBuscarEstadoPagoClick}>
                    <i className="bi bi-search"></i> Buscar
                  </button>
                </div>   
              </div>
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center border-bottom-0 p-3 bg-white">
                  <h4>Reporte Estados de Pago</h4>
                  <div className="d-flex gap-md-2">
                    <div className="input-group w-auto">
                      <span className="input-group-text" id="search-folio">
                        <i className="bi bi-search"></i>
                      </span>
                      <input type="text" className="form-control" placeholder="Folio..." aria-describedby="search-folio" onChange={manejarCambioFiltro}/>
                    </div>
                    {estadosPago.length > 0 ? (
                      <button className="btn btn-success" onClick={exportToExcel}><i className="bi bi-download"></i> Exportar Excel</button>
                    ) : (
                      <button className="btn btn-success" disabled><i className="bi bi-download"></i> Exportar Excel</button>
                    )}
                  </div>
                </div>
                <div className="card-body card-body-fh card-body-filter p-0">
                  <div className="table-responsive mytable-container">
                    <table className="table table-hover mb-0">
                      <thead>
                        <tr className="table-active border-top border-bottom">
                          <th scope="col" className="ps-3">Maquinaria</th>
                          <th scope="col">Folio</th>
                          {/* <th scope="col">Factura</th> */}
                          <th scope="col">Fecha</th>
                          <th scope="col">Cliente</th>
                          <th scope="col">Obra</th>
                          <th scope="col">Descuentos</th>
                          <th scope="col">Total Neto</th>
                          <th scope="col">Iva</th>
                          <th scope="col" className="fw-bold text-dark pe-3">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {estadosPagoFiltrados.length > 0 ? (
                          estadosPagoFiltrados.map((estadoPago, index) => (
                            <tr key={index}>
                              <td className="ps-3">{estadoPago.nombre_maquinaria}</td>
                              <td>{estadoPago.folio}</td>
                              {/* <td></td> */}
                              <td>{estadoPago.fecha_estado_pago}</td>
                              <td>{estadoPago.nombre_cliente}</td>
                              <td>{estadoPago.nombre_obra}</td>
                              <td>$ {parseFloat(estadoPago.otros_descuentos).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</td>
                              <td>$ {parseFloat(estadoPago.total_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</td>
                              <td>$ {parseFloat(estadoPago.iva).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</td>
                              <td className="pe-3">$ <span className="text-orange">{parseFloat(estadoPago.total).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</span></td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={10}>No se encontraron estados de pago</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  mainContainer: {
    height: "100vh",
  },
};

export default ReporteEstadoPago;
